import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Ask_Question,
  Pre_Loading,
  Show_Message,
} from "../General/Messagedialogbox";
import $ from "jquery";
import { API_FETCH, API_POST, DecryptData } from "../General/Utility";
function PriceGroupPopup(props) {
  const dispatch = useDispatch();
  const _AuthParems = useSelector((state) => state.Common.Admin);
  const iScrId = 80;
  const [strPrefix, setstrPrefix] = useState("");
  const [iNumSeqNo, setiNumSeqNo] = useState(0);
  const strPGCodeTag = "Enter PriceGroup Code";

  const [bIsDefault, setbIsDefault] = useState(false);

  const [strPGCode, setstrPGCode] = useState("");
  const [iPGrpId, setiPGrpId] = useState(0);
  const [strPGrpName, setstrPGrpName] = useState("");
  const [strDescription, setstrDescription] = useState("");
  const [dDiscount, setdDiscount] = useState((0).toFixed(2));
  const [strSearch, setstrSearch] = useState("");
  const [ListPriceGRP, setListPriceGRP] = useState([]);
  const [ManualCode, setManualCode] = useState(true);
  const [BtnSaveDisable, setBtnSaveDisable] = useState(false);
  const [BtnDeleteDisable, setBtnDeleteDisable] = useState(false);
  useEffect(() => {
    Load_PriceGroup();
  }, []);
  const Load_PriceGroup = async () => {
    try {
      const _LocalParems = await DecryptData(localStorage.jbctrlparams);
      const res = await API_FETCH(
        `PriceGroupMaster/Load_PriceGroup/${Number(_LocalParems.Branch)}/${
          _LocalParems.DB
        }`,
        dispatch
      );
      if (res) {
        setListPriceGRP(res.objEntPRG);
        setstrPGCode(res.objCodFormate[0].strCode);
        setstrPrefix(res.objCodFormate[0].strPrefix);
        setiNumSeqNo(res.objCodFormate[0].iNumSeqNo);
        setManualCode(!res.objCodFormate[0].isManualNo);

        ButtonPermission(_LocalParems.MasterPer, iPGrpId);
      }
    } catch (err) {
      Show_Message(dispatch, err, "error");
    }
  };
  const SaveClick = async () => {
    try {
      Pre_Loading(dispatch, true);
      const InsUpdPG = {
        strPGCode: strPGCode,
        iPGrpId: iPGrpId,
        strPGrpName: strPGrpName,
        dDiscount: Number(dDiscount),
        bIsDefault: bIsDefault,
        iTitleTag: iScrId,
        iNumSeqNo: iNumSeqNo,
        strPrefix: strPrefix,
        strDescription: strDescription,
        dMinMargin: 0,
        strPGCodeTag: strPGCodeTag,
        strSearch: strSearch,
        strFilter: "",
        strFilterColumn: "All",
        strDBName: _AuthParems.DB,
        iBranchId: Number(_AuthParems.Branch),
      };
      const res = await API_POST(
        "PriceGroupMaster/InsUpd_PriceGroup/",
        InsUpdPG,
        dispatch
      );
      if (res) {
        Show_Message(dispatch, res.strMessage, "success");
        ClearClick();
      }
    } catch (err) {
      Show_Message(dispatch, err, "error");
    }
  };
  const ClearClick = () => {
    setstrPGCode("");
    setiPGrpId(0);
    setstrPGrpName("");
    setbIsDefault(false);
    setstrDescription("");
    setdDiscount((0.0).toFixed());
    setBtnDeleteDisable(false);
    setBtnSaveDisable(false);
    Load_PriceGroup();
  };
  const DeleteClick = async () => {
    try {
      Pre_Loading(dispatch, true);
      const res = await API_POST(
        "PriceGroupMaster/Delete_PriceGroup/" +
          Number(_AuthParems.Branch) +
          "/" +
          iPGrpId +
          "/" +
          bIsDefault +
          "/" +
          _AuthParems.DB,
        dispatch
      );
      if (res) {
        Show_Message(dispatch, res.strMessage, "success");
        ClearClick();
      }
    } catch (err) {
      Pre_Loading(dispatch, false);
      Show_Message(dispatch, err, "error");
    }
  };
  const View_PriceGroup = async (iPGrpId) => {
    try {
      Pre_Loading(dispatch, true);
      const res = await API_FETCH(
        "PriceGroupMaster/View_PriceGroup/" +
          iPGrpId +
          "/" +
          Number(_AuthParems.Branch) +
          "/" +
          _AuthParems.DB,
        dispatch
      );
      if (res) {
        let EntPG = res.EntPG[0];
        setstrPGCode(EntPG.strPGCode);
        setiPGrpId(EntPG.iPGrpId);
        setstrPGrpName(EntPG.strPGrpName);
        setbIsDefault(EntPG.bIsDefault);
        setdDiscount(EntPG.dDiscount);
        setstrDescription(EntPG.strDescription);
        ButtonPermission(_AuthParems.MasterPer, EntPG.iPGrpId);
      }
    } catch (err) {
      Pre_Loading(dispatch, false);
      Show_Message(dispatch, err, "error");
    }
  };
  const Search_PriceGroup = async (SearchText) => {
    try {
      setstrSearch(SearchText);
      SearchText = SearchText === "" ? "null" : SearchText;
      const res = await API_FETCH(
        "PriceGroupMaster/Search_PriceGroup/" +
          SearchText +
          "/" +
          _AuthParems.DB,
        dispatch
      );
      if (res) {
        setListPriceGRP(res);
      }
    } catch (err) {
      Show_Message(dispatch, err.strMessage, "error");
    }
  };
  const ButtonPermission = (Menu, PgId) => {
    Menu = Menu.groups.filter((Data) => Data.iScrId === 62);
    if (Menu.length > 0) {
      if (Number(PgId) > 0) {
        setBtnSaveDisable(!Menu[0].isModify);
        setBtnDeleteDisable(!Menu[0].isDelete);
      }
      if (Number(PgId) === 0) {
        setBtnSaveDisable(!Menu[0].isCreate);
      }
    }
  };
  return (
    <div className="popup-container">
      <div className="popup-content">
        <div className="popup-header">
          <h5>Price Group Master </h5>
          <div className="icon-popup-btn-grp">
            <span className="icon-btn" onClick={(e) => props.Close()}>
              <i className="fa-regular fa-rectangle-xmark"></i>
            </span>
          </div>
        </div>
        <div className="popup-body">
          <div className="row p-0">
            <div className="col-sm-12 col-md-5">
              <div className="m-hsearch mt-1">
                <input
                  type="search"
                  placeholder="Search Price Group"
                  onKeyDown={(e) => {
                    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                      $(".data-list [tabindex=0]").focus();
                    }
                  }}
                  value={strSearch}
                  onChange={(e) => {
                    Search_PriceGroup(e.target.value);
                  }}
                  autoFocus
                />

                <i
                  className="fas fa-search"
                  onClick={(e) => props.Search(props.strSearchtxt)}
                ></i>
              </div>
              <div className="data-list">
                {ListPriceGRP.map((pg, Index) => (
                  <button
                    key={Index}
                    tabIndex={Index}
                    onKeyDown={(e) => {
                      const arrlength = props.arrMasterData.length - 1;
                      if (e.key === "ArrowDown") {
                        if (Index === arrlength)
                          $(`.data-list [tabindex=${Index + 1}]`).focus();
                        else $(`.data-list [tabindex=${0}]`).focus();
                      }
                      if (e.key === "ArrowUp") {
                        if (Index === 0)
                          $(`.data-list [tabindex=${arrlength}]`).focus();
                        else $(`.data-list [tabindex=${Index - 1}]`).focus();
                      }
                      if (e.key === "Enter") {
                        View_PriceGroup(pg.iPGrpId);
                      }
                    }}
                  >
                    <label onClick={(e) => View_PriceGroup(pg.iPGrpId)}>
                      {pg.strPGrpName}
                    </label>
                  </button>
                ))}
              </div>
            </div>
            <div className="col-sm-12 col-md-7">
              <div className="col-md-12 col-sm-12 mt-1">
                <label>
                  Code<span className="danger">*</span>
                </label>
                <div className="d-inline-flex " style={{ width: "100%" }}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder=""
                    aria-label="Recipient's username"
                    aria-describedby="button-addon2"
                    value={strPGCode}
                    readOnly={ManualCode}
                    onChange={(e) => setstrPGCode(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-md-12 col-sm-12 mt-1">
                <label>
                  Name <span className="danger">*</span>
                </label>
                <input
                  type="text"
                  aria-label="First name"
                  className="form-control"
                  value={strPGrpName}
                  onChange={(e) => setstrPGrpName(e.target.value)}
                  autoFocus
                  placeholder="Price Group Name"
                />
              </div>
              <div className="col-md-12 col-sm-12 mt-1">
                <label>Discount</label>
                <input
                  type="number"
                  aria-label="First name"
                  className="form-control"
                  value={dDiscount}
                  onClick={(e) => e.target.select()}
                  onBlur={(e) => {
                    if (e.target.value === "") {
                      setdDiscount((0).toFixed(2));
                    } else setdDiscount(parseFloat(dDiscount).toFixed(2));
                  }}
                  onChange={(e) => setdDiscount(e.target.value)}
                />
              </div>
              <div className="col-md-12 col-sm-12 mt-1">
                <label>Description</label>
                <input
                  type="text"
                  aria-label="First name"
                  className="form-control"
                  value={strDescription}
                  onChange={(e) => setstrDescription(e.target.value)}
                  placeholder="Description"
                />
              </div>
              <div className="col-md-12 col-sm-12 text-nowrap">
                <label>Is Default</label>
                <br />
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={bIsDefault}
                    onChange={(e) => setbIsDefault(!bIsDefault)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="popup-footer">
          <div className="popup-btn-group">
            <button
              type="button"
              className="btn-fabgreen"
              disabled={BtnSaveDisable}
              onClick={(e) => {
                if (strPGCode === "") {
                  Show_Message(dispatch, "Please Enter Code", "error");
                } else if (strPGrpName === "") {
                  Show_Message(dispatch, "Please Enter Name", "error");
                } else if (dDiscount === 0) {
                  Show_Message(dispatch, "Please Enter Discount", "error");
                } else {
                  Ask_Question(
                    dispatch,
                    SaveClick,
                    "Do You Want to  Save Price Group?"
                  );
                }
              }}
            >
              Save &nbsp; <i className="fas fa-Save"></i>
            </button>
            <button
              type="button"
              className="btn-fabgreen"
              disabled={BtnDeleteDisable}
              onClick={(e) => {
                if (iPGrpId === 0) {
                  Show_Message(dispatch, "Please Select PriceGroup", "error");
                } else {
                  Ask_Question(
                    dispatch,
                    DeleteClick,
                    "Do You Want to  Delete Price Group?"
                  );
                }
              }}
            >
              Delete &nbsp; <i className="fas fa-print"></i>
            </button>
            <button type="Reset" className="btn-fabgreen" onClick={ClearClick}>
              Clear &nbsp; <i className="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default PriceGroupPopup;
